var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoodstackPageLogo = function SvgGoodstackPageLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.431 13.431 0 30 0h452c16.569 0 30 13.431 30 30v452c0 16.569-13.431 30-30 30H30c-16.569 0-30-13.431-30-30V30z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.753 228.776C189.711 228.776 136 175.037 136 109h58.064c0 34.031 27.682 61.7 61.689 61.7 34.025 0 61.689-27.687 61.689-61.7h58.064c0 66.054-53.711 119.776-119.753 119.776zM375.506 257.813H136v58.075h239.506v-58.075zM375.506 344.925H136V403h239.506v-58.075z",
    fill: "#8B4AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoodstackPageLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "goodstack-page-logo.f7d11c369f7c553280ca38931d45d2f6.svg";